// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".bf6d3d9a4c6b9e7e70f218469c9bda76.js";
};